import { createContext, useContext, type ReactNode } from "react";

import type { AssistantEvent } from "@/components/assistant/types";

export interface WorklogEntry {
  messageId: string;
  event: AssistantEvent;
}

interface WorklogContextValue {
  entries: WorklogEntry[];
}

const WorklogContext = createContext<WorklogContextValue | null>(null);

export function WorklogProvider({ entries, children }: { entries: WorklogEntry[]; children: ReactNode }) {
  return <WorklogContext.Provider value={{ entries }}>{children}</WorklogContext.Provider>;
}

export function useWorklog(): WorklogContextValue {
  const context = useContext(WorklogContext);
  if (!context) {
    throw new Error("useWorklog must be used within WorklogProvider");
  }
  return context;
}
